<template>
  <div class="fill-height">
    <v-row align="center" justify="center" class="fill-height ma-0">
      <v-col class="text-center px-5" cols="12">
        <img :src="img" :style="`width:${imgSize}px;max-width:${imgSize}px;margin-bottom:20px;`" class="emoji-bemvindo" />
      </v-col>
    </v-row>
    <v-footer app color="primary" class="text-center">
      <div class="fill-heigth max-width">
        <img src="@/assets/bemvindo/powered.png" />
        <img src="@/assets/bemvindo/comentaai.png" />
      </div>
    </v-footer>
  </div>
</template>

<script>
export default {
  props: {
    loja: String,
    text: String,
    img: String,
    imgSize: String,
    clientName: String
  },
}
</script>

<style>

.max-width {
  width: 100%;
}

.emoji-bemvindo {
  max-width: 120px;
  text-align: center;
  margin: auto auto;
}

</style>
